import React from 'react'

import { Metadata } from '@scoir/tracking'
import PropTypes from 'prop-types'

import { FIELDS, PAGES } from 'common/metadata-constants'
import { DOMAIN_TYPES } from 'common/track-event-constants'
import { StudentCollegeCompareProvider } from 'components/CollegeCompare'

import Navigation from './Navigation'

export const TOP_NAVIGATION_HEIGHT_ID = 'top-navigation'

/**
 * Component at the top for navigating the app
 * @param {Object} props
 * @returns HeaderNavigation Component
 */
const HeaderNavigation = (props) => {
  return (
    <Metadata
      value={{
        [FIELDS.PAGE]: PAGES.GLOBAL_HEADER,
        [FIELDS.DOMAIN_TYPE]: DOMAIN_TYPES.COLLEGE_PROFILE,
        [FIELDS.CURRENT_URL]: props.location.pathname,
      }}
    >
      <StudentCollegeCompareProvider>
        <Navigation {...props} />
      </StudentCollegeCompareProvider>
    </Metadata>
  )
}

HeaderNavigation.propTypes = {
  skipNavId: PropTypes.string,
  location: PropTypes.object,
}

export default HeaderNavigation
